import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import AboutHero from '../components/about/AboutHero';
import AboutStats from '../components/about/AboutStats';
import WhyChooseUs from '../components/about/WhyChooseUs';
import OurServices from '../components/about/OurServices';

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="About Us"
        description="Clik Technologies is a digital design and development company. 70+ team members, 100+ completed projects, 15+ years helping startups and enterprises build world-class digital products."
        path="/about"
      />
      <Header />
      <AboutHero />
      <AboutStats />
      <WhyChooseUs />
      <OurServices />
      <Footer />
    </div>
  );
};

export default About;
